import { render, staticRenderFns } from "./textbox.vue?vue&type=template&id=c53302da&scoped=true"
import script from "./textbox.vue?vue&type=script&lang=js"
export * from "./textbox.vue?vue&type=script&lang=js"
import style0 from "./textbox.vue?vue&type=style&index=0&id=c53302da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53302da",
  null
  
)

export default component.exports